import {
  ComplaintsCategoriesDocument,
  DeleteComplaintsCategoryDocument,
  DeleteComplaintsCategoryMutation,
  DeleteComplaintsCategoryMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useDeleteComplaintsCategory = () => {
  const [executeMutation] = useMutation(DeleteComplaintsCategoryDocument, {
    extractorFn: (data: DeleteComplaintsCategoryMutation) =>
      data.complaintsMutations.deleteComplaintsCategory,
  })

  const deleteComplaintsCategory = async (variables: DeleteComplaintsCategoryMutationVariables) => {
    return executeMutation({
      variables,
      refetchQueries: [ComplaintsCategoriesDocument],
    })
  }

  return {
    deleteComplaintsCategory,
  }
}
